import has from 'lodash/has';

export default obj => {
  let str = [];
  for (const p in obj)
    if (has(obj, p)) {
      str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
    }
  return str.join('&');
};
